import * as React from "react";
import FormFieldProps from "components/form/FormFieldProps";
import * as _ from "lodash";
import {ProjectResource, AccountResource} from "client/resources";
import {repository} from "clientInstance";
import { BoundSelect } from "components/form/Select/Select";
import Note from "components/form/Note/Note";

export interface AzureResourceGroupSelectorProperties {
    "Octopus.Action.Azure.ResourceGroupName": string;
}

interface AzureResourceGroupSelectorProps {
    projectId: string;
    localNames: string[];
    isAccountBound: boolean;
    accountId: string;
    properties: AzureResourceGroupSelectorProperties;
    getFieldError(field: string): string;
    setProperties(properties: Partial<AzureResourceGroupSelectorProperties>): void;
    doBusyTask(action: () => Promise<void>): Promise<boolean>;
}

interface AzureResourceGroupSelectorState {
    account: AccountResource;
    resourceGroups: any[];
}

export default class AzureResourceGroupSelector extends React.Component<AzureResourceGroupSelectorProps, AzureResourceGroupSelectorState> {

    constructor(props: AzureResourceGroupSelectorProps) {
        super(props);
        this.state = {
            account: null,
            resourceGroups: []
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps: AzureResourceGroupSelectorProps, prevState: AzureResourceGroupSelectorState) {
        if (prevProps.accountId !== this.props.accountId) {
            this.loadData();
        }
    }

    componentWillReceiveProps(newprops: AzureResourceGroupSelectorProps) {
        if (!newprops.isAccountBound && newprops.accountId !== this.props.accountId) {
            this.loadData();
        }
    }

    async loadData() {
        this.props.doBusyTask(async () => {
            if (!this.props.isAccountBound && this.props.accountId) {
                const account = await repository.Accounts.get(this.props.accountId);
                const resourceGroups: any = await repository.Accounts.getResourceGroups(account);
                this.setState({
                    account,
                    resourceGroups: Object.keys(resourceGroups).map(item => resourceGroups[item])
                });
            } else {
                this.setState({
                    account: null,
                    resourceGroups: []
                });
            }
        });
    }

    render() {
        return <div>
            <BoundSelect
                variableLookup={{
                    localNames: this.props.localNames,
                    projectId: this.props.projectId
                }}
                resetValue={this.props.properties["Octopus.Action.Azure.ResourceGroupName"]}
                isBound={this.props.isAccountBound}
                hideBindButton={this.props.isAccountBound}
                value={this.props.properties["Octopus.Action.Azure.ResourceGroupName"]}
                onChange={(val) => this.props.setProperties({["Octopus.Action.Azure.ResourceGroupName"]: val})}
                items={this.state.resourceGroups.map(item => ({ value: item.Name, text: item.Name }))}
                label="Resource Group"
                allowClear={true}
                allowFilter={true}
                error={this.props.getFieldError("Octopus.Action.Azure.ResourceGroupName")} />
            <Note>The name of the Azure Resource Group. The Resource Group must exist.</Note>
            <Note>A Resource Group can be created through the Azure Portal, or by using the New-AzureRMResourceGroup PowerShell cmdlet.</Note>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/azureResourceGroup/AzureResourceGroupSelector.tsx